module.exports = __webpack_public_path__ + "static/img/homeGoal.91c1976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/homeGoal.png
// module id = CMY2
// module chunks = 94